import React from 'react'
import { IHero as IContentfulHero } from 'marketing-site/@types/generated/contentful'
import {
  IProps as IHero,
  Hero,
  IHeroContentAlignment,
  ILayout,
  IHeroVerticalLayout,
} from 'marketing-site/src/library/components/Hero'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformCheckmarks } from '../elements/ContentfulCheckmarks'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'

export const ContentfulHero = (hero: IContentfulHero) => (
  <EntryMarker entry={hero}>{() => <Hero {...transformHeroHeading(hero)} />}</EntryMarker>
)

function getLayoutFromData(
  alignment: IHeroContentAlignment,
  verticalLayout: IHeroVerticalLayout,
): ILayout {
  return {
    leftAlign: alignment === 'Left',
    compact: verticalLayout === 'Compact',
  }
}

export function transformHeroHeading({ fields }: IContentfulHero): IHero {
  return {
    ...fields,
    checkmarks: fields.checkmarks && transformCheckmarks(fields.checkmarks),
    layout: getLayoutFromData(fields.alignment, fields.verticalLayout),
    avatars: fields.avatars && fields.avatars.slice(0, 3).map((avatar) => transformImage(avatar)),
  }
}
